export default __webpack_public_path__ + "static/media/rec_2.7c7ed82b.jpg";